import { render } from "./StockProductsListPage.vue?vue&type=template&id=e54490ae&ts=true"
import script from "./StockProductsListPage.vue?vue&type=script&lang=ts"
export * from "./StockProductsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__